module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.68ea473.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/Roboto-Medium.ttf
// module id = PrlG
// module chunks = 0